import { render, staticRenderFns } from "./employer-notes-wrapper.vue?vue&type=template&id=24e59b1e"
import script from "./employer-notes-wrapper.vue?vue&type=script&lang=js"
export * from "./employer-notes-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports